export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
export const LOCATION_STATUS = {
  ACTIVE,
  INACTIVE
}

export const GENERAL = 'general'
export const CONTENT = 'content'
